import {PreferencesPageComponent} from './components/preferencesPage/PreferencesPageComponent';
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter';

customElements.get('preferences-page-component') || customElements.define('preferences-page-component', PreferencesPageComponent);